import { memo } from "react";
import type { SvgProps } from "react-native-svg";
import Svg, { Path } from "react-native-svg";

const SvgVerifiedBig = (props: SvgProps) => (
  <Svg width={32} height={36} fill="none" {...props}>
    <Path
      stroke={props.color}
      strokeLinejoin="round"
      strokeWidth={3}
      d="m2 6.143 14.007-4.088L30 6.143v8.383a20.47 20.47 0 0 1-13.998 19.418A20.47 20.47 0 0 1 2 14.522z"
    />
    <Path stroke={props.color} strokeWidth={3} d="m9 16.555 5 5 10-9.5" />
  </Svg>
);
const Memo = memo(SvgVerifiedBig);
export default Memo;
